import type { LoaderFunctionArgs } from "@remix-run/cloudflare";
import { json } from "@remix-run/cloudflare";
import { ShareCreationFlow } from "../components/features/index/ShareCreationFlow";
import { ShareLandingPage } from "../components/features/index/ShareLandingPage";
import { useIndexPageContext } from "../hooks/useIndexPageContext";
import { createTranslatedMeta } from "../utils/routeMeta";
export async function loader(_args: LoaderFunctionArgs) {
	return json({ ok: true as const });
}
export const meta = createTranslatedMeta({
	titleKey: "meta.indexTitle",
	descriptionKey: "meta.indexDescription",
	path: "/",
	image: "https://gsplat.org/images/gsplat-share-social.jpg",
});
export default function Index() {
	const context = useIndexPageContext();
	if (!context.file) {
		return (
			<>
				<input
					ref={context.fileInputRef}
					type="file"
					accept=".ply,.spz,.sog,.html"
					onChange={context.handleFileInputChange}
					className="hidden"
				/>
				<ShareLandingPage
					onChooseFile={context.openFileDialog}
					onFileSelect={context.selectFile}
					selectionError={context.selectionError}
				/>
			</>
		);
	}
	return (
		<div className="share-creation-shell">
			<main>
				<input
					ref={context.fileInputRef}
					type="file"
					accept=".ply,.spz,.sog,.html"
					onChange={context.handleFileInputChange}
					className="hidden"
				/>
				<ShareCreationFlow context={context} />
			</main>
		</div>
	);
}
